<template>
  <div class="card card-modal">
    <div class="card-header">
      Selecionar uma agenda
    </div>

    <div class="alert col alert-warning col" v-if="lista.length == 0">
      <strong>Atenção!</strong> Nenhuma agenda encontrada
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col">

          <table class="table table-dark table-striped pointer" id="tableSelectAgenda">
            <tbody >
              <tr v-for="ag in lista" :key="ag._id" :class="{ rowActive: ag._id == selectedAg._id }" @click="selectedAg = ag">
                <td> {{ag.nome}} </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row card-footer ">
      <div class="col">
        <button class="btn btn-success btn-sm col-6 btn-danger" @click="$emit('close')">
          Fechar
        </button>
        <button class="btn btn-success btn-sm col-6 btn-success" @click="select()">
          Selecionar
        </button>
      </div>
    </div>
  </div>

</template>

<script>

import EventBus from './../../core/eventBus';

export default {
  data() {
    return {
      selectedAg: {},
      lista: [],
    }
  },
  methods: {
    async listAll(){

      let response = await this.$http.get(`/v1/v3/agenda/0/1000`);
      if (response.data) {
        this.lista = response.data;
      }
    },
    select(){
      this.$emit('close');
      EventBus.$emit('setAgenda', this.selectedAg);
    }
  },
  async mounted() {
    this.listAll();
  },

};
</script>
